<script setup lang="ts">

import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import {DotLottieVue} from "@lottiefiles/dotlottie-vue";
</script>

<template>
  <BaseCard class="bg-white rounded-md">
    <BaseCardBody class="space-y-2">
      <h2 class="text-black">
        Vous souhaitez diffuser l'app auprès de vos patients ?
      </h2>
      <div class="flex gap-4 items-center">
        <div>
          <DotLottieVue src="animations/app-megaphone.lottie" class="h-36 w-36" autoplay loop />
        </div>
        <div class="flex-1">
          <p>Nous avons ce qu'il vous faut !</p>
          <p>- Flyers au comptoir</p>
          <p>- Vidéos sur vos écrans</p>
          <p>- SMS prêts à envoyer</p>
        </div>
        <div class="self-end">
          <router-link :to="{name: 'patient-administration.application.attachments'}">
            <span class="text-primary font-bold">Voir les ressources de diffusion ></span>
          </router-link>
        </div>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<style scoped>

</style>
